import {Space} from "antd";
import {ServiceCoverImagesFormFieldsProps} from "./types";
import {NewOfferingCoverImagesUpload} from "../../general/cover-images";

export function ServiceCoverImagesFormFields({
  accordionIndex,
  defaultCoverImages,
  deleteCoverImage,
  isDeleteLoading,
  isUploadLoading,
  offeringId,
  uploadCoverImages,
}: ServiceCoverImagesFormFieldsProps) {
  return (
    <Space direction="vertical" size={16} style={{display: "flex"}}>
      <NewOfferingCoverImagesUpload
        defaultCoverImages={defaultCoverImages}
        deleteCoverImage={deleteCoverImage}
        isDeleteLoading={isDeleteLoading}
        isUploadLoading={isUploadLoading}
        offeringId={offeringId}
        uploadCoverImages={uploadCoverImages}
        offeringType="product-service"
      />
    </Space>
  );
}
